export const HOME_PROJECT_COLOR = "#8E8E93";
// Theme-flipping token defined in index.css — near-white in dark,
// dark zinc in light so the Home active space dot stays visible.
export const HOME_ACTIVE_SPACE_COLOR = "var(--denker-home-active-space-color)";

export function projectColorForDisplay({
  color,
  isHome,
}: {
  color: string;
  isHome?: boolean;
}) {
  if (isHome) {
    return HOME_PROJECT_COLOR;
  }
  return color;
}
